import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		price: Yup.number()
			.required(t("fill_required_fields"))
			.min(0.01, t("price_proposal_has_to_be_greater_than_zero")),
	});
};
